export default __webpack_public_path__ + "static/media/q3.a8b45484.jpg";